/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1172
 */

module.exports = function (e) {
  return function (t) {
    return e(t)
  }
}
